import PropTypes from 'prop-types';
import React from 'react';

import BackdropComponent from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import {styled} from '@mui/material/styles';

const Backdrop = styled(BackdropComponent)(({theme}) => ({
  color: theme.palette.common.white,
  zIndex: theme.zIndex.modal,
  '&:before': {
    content: '""',
    border: '2px dashed',
    color: theme.palette.common.white,
    outline: 'none',
    position: 'absolute',
    top: theme.spacing(3),
    right: theme.spacing(3),
    bottom: theme.spacing(3),
    left: theme.spacing(3),
  },
}));

const DropTarget = ({open, onDragEnter, onDragLeave, onDrop, ...props}) => {
  const dragEnter = event => {
    if (onDragEnter) {
      onDragEnter(event);
    }
  };

  const dragLeave = event => {
    if (onDragLeave) {
      onDragLeave(event);
    }
  };

  const dragOver = event => {
    event.preventDefault();
    event.stopPropagation();
  };

  const drop = event => {
    event.preventDefault();
    if (onDrop) {
      onDrop(event);
    }
  };

  return (
    <Backdrop
      open={open}
      onDragEnter={dragEnter}
      onDragLeave={dragLeave}
      onDragOver={dragOver}
      onDrop={drop}
      {...props}
    >
      <Box padding={4} textAlign="center" color="inherit">
        {props.children}
      </Box>
    </Backdrop>
  );
};

DropTarget.propTypes = {
  children: PropTypes.node,
  onDragEnter: PropTypes.func,
  onDragLeave: PropTypes.func,
  onDrop: PropTypes.func,
  open: PropTypes.bool.isRequired,
};

export default DropTarget;
